import { Component } from '@angular/core';

@Component({
  selector: 'era-panel-footer',
  templateUrl: './panel-footer.component.html',
})
export class PanelFooterComponent {}
